import { useMutation, useQuery } from 'react-query';
import { AppSettings } from './models/appsettings.model';
import { appSettingsService } from '../services/appsettings.service';
import { useIsLoggedIn } from '../hooks/use-auth';

export function useGetAppSettingsQuery() {
    const isLoggedIn = useIsLoggedIn();

    return useQuery(
        ["appsettings"],
        () => appSettingsService.get(),
        {
            enabled: isLoggedIn // ✅ only runs when logged in
        }
    );
}
export function useSetAppSettingsMutation() {
    return useMutation((request: AppSettings) => appSettingsService.set(request));
}